<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.client-administration.overview.title"></app-title-bar>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
            class="grid-with-toolbar grid-with-footer"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [filterSettings]="filterSettings"
            [allowFiltering]="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [editSettings]="editSettings"
            [searchSettings]="searchOptions"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event)">
    <ng-template #toolbarTemplate
                 let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.third-party-user-assignment-administration.overview.add' | translate"
                  prefixIcon="e-icons icon-add"
                  (click)="onAdd()"></e-item>
          <e-item [text]="'i18n.domain.third-party-user-assignment-administration.overview.bulkDelete' | translate"
                  prefixIcon="e-icons icon-add"
                  (click)="onBulkDelete()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field="id"
                [visible]="false"
                [isPrimaryKey]="true"></e-column>
      <e-column field="user.userName"
                type="string"
                headerText="{{'i18n.domain.third-party-user-assignment-administration.grid.userName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="zone.name"
                type="string"
                headerText="{{'i18n.domain.third-party-user-assignment-administration.grid.zoneName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="{{zonePathFieldName}}"
                [allowFiltering]="false"
                [allowSorting]="false"
                type="string"
                headerText="{{'i18n.domain.third-party-user-assignment-administration.grid.zonePath' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="client.name"
                type="string"
                headerText="{{'i18n.domain.third-party-user-assignment-administration.grid.zoneClientName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column headerText=""
                [commands]="gridCommands" width="145px"></e-column>
    </e-columns>
  </ejs-grid>
</div>
<app-third-party-user-assignment-edit-dialog (refreshData)="onRefreshData()"></app-third-party-user-assignment-edit-dialog>
